import _px2rem from './px2rem.js'

export const px2rem = _px2rem
